// extracted by mini-css-extract-plugin
export default {"container":"login_container__V7C2q","card":"login_card__HiiQH","leftSide":"login_leftSide__1tFRb","logo":"login_logo__VZqZ0","rightSideImg":"login_rightSideImg__GB-ke"};